<script lang="ts" setup>
import Popup from "@/components/global/Popup.vue";
import { useGlobalData } from '@/utils/useGlobal';
import { isShowCustomerServicePop, closeCustomerServicePop } from "../socialMedia"

const { config } = useGlobalData()
</script>
<template>
  <popup :value="isShowCustomerServicePop"  @input="closeCustomerServicePop">
    <div class="popup_wrap small">
      <div v-if="config.service" class="contact-pop">
        <div class="qrcode-box">
          <img :src="config.service" alt="客服" class="wx-img">
          <p v-if="config.serviceDesc" class="wx-desc">{{ config.serviceDesc }}</p>
        </div>
      </div>
      <button class="close" @click="closeCustomerServicePop"></button>
    </div>
  </popup>
</template>

<style lang="less" scoped>
@import "@/assets/css/socialMedia.less";
</style>
